import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

const hexToRgb = (hex) => {
  if (!hex) return null;
  const m = hex.replace("#", "").match(/^([0-9a-f]{6})$/i);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
};

const applyBrand = (brand = {}) => {
  const map = {
    primary_color: "--ink-rgb",
    accent_color: "--warm-rgb",
    background_color: "--linen-rgb",
    card_color: "--cream-rgb",
  };
  Object.entries(map).forEach(([k, cssVar]) => {
    const rgb = hexToRgb(brand[k]);
    if (rgb) document.documentElement.style.setProperty(cssVar, rgb);
  });
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => {
      setSettings(data);
      applyBrand(data.brand || {});
      if (data.brand?.name) document.title = data.brand.name;
    }).catch(() => setSettings({}));
  }, []);

  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
}
